import React from "react";
import { cx } from "../utils";

/**
 * CcFilterChip — compact filter pill for alert status / severity rows.
 * Variants: neutral (status), severity-high, severity-medium, severity-low.
 */
const CcFilterChip = ({
  label,
  count,
  active = false,
  variant = "neutral",
  showDot = false,
  onClick,
  className,
  ...props
}) => {
  const displayCount = count > 0 ? count : null;

  return (
    <button
      type="button"
      className={cx(
        "cc-filter-chip",
        `cc-filter-chip--${variant}`,
        active && "is-active",
        className,
      )}
      onClick={onClick}
      {...props}
    >
      {showDot ? <span className="cc-filter-chip__dot" aria-hidden /> : null}
      <span className="cc-filter-chip__label">{label}</span>
      {displayCount != null ? (
        <span className="cc-filter-chip__count">{displayCount}</span>
      ) : null}
    </button>
  );
};

export default CcFilterChip;
